<template>
  <div>
    <v-dialog v-model="open" max-width="720px">
      <v-card>
        <v-card-title>連絡メール詳細</v-card-title>

        <v-card-text>
          <v-table v-if="chat" class="pt-4">
            <template v-slot:default>
            <tbody>

              <tr>
                <td>日付</td>
                <td>{{ chat.date }}</td>
              </tr>
              <tr>
                <td>宛先</td>
                <td class="pb-2">
                  <div class="text-caption font-weight-bold mt-2 text-grey-darken-1">クラス</div>
                  <div>
                    {{ (chat.to.groups.length == 0 && chat.to.children.length == 0) ? getClassNames(chat.to.classes) : '' }}
                  </div>
                  
                  <div class="text-caption font-weight-bold mt-2 text-grey-darken-1">グループ</div>
                  <div>
                    {{ getGroupNames(chat.to.groups) }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>タイトル</td>
                <td>{{ chat.title }}</td>
              </tr>
              <tr>
                <td>本文</td>
                <td>{{ chat.body }}</td>
              </tr>
              <tr>
                <td>未読数</td>
                <td>{{ chat.chatUnReadCount + '人' }}</td>
              </tr>
              <tr>
                <td>既読数</td>
                <td>{{ chat.chatReadCount + '人' }}</td>
              </tr>
              <tr>
                <td>既読者</td>
                <td>
                  <div v-for="(item, i) in sortedReadClassChildren" :key="i">
                    <div class="text-caption font-weight-bold mt-2 text-grey-darken-1">{{ String(item.year) }}年度 {{ item.className }}</div>
                    <div v-for="child in item.children" :key="child.childId">
                      {{ child.lastName + child.firstName }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>添付ファイル</td>
                <td>
                  <v-img v-if="chat.attachmentUrls?.length > 0" :src="chat.attachmentUrls[0]"></v-img>
                  <v-row>
                    <v-col cols="12" v-for="(item, i) in chat.attachmentUrls" :key="i" class="py-2 mt-4">
                      <v-btn
                        :href="item"
                        target="_blank"
                        color="primary"
                        variant="outlined"
                        size="small" >
                        {{ `添付ファイル${i+1}` }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </td>
              </tr>

            </tbody>
            </template>
          </v-table>
        </v-card-text>

        <v-card-actions>
          <v-container>
            <v-row>
              <v-btn @click="close" color="grey" variant="text">閉じる</v-btn>
              <v-spacer />
              <v-btn v-if="isDraft" @click="editMessage" color="primary" variant="flat">編集</v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import DialogMixin from '@/mixins/DialogMixin'
import { chatEditModule } from '@/store/dataModules/chatEditModule'
import { GroupChatResponse, NurseryGroupListResponse } from 'chaild-api/lib'
import { NurseryUserClassResponse } from 'chaild-api/src/component/nursery/user/types'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ChatDetailDialog',

  mixins: [DialogMixin],

  props: {
    chat: {
      type: Object as PropType<GroupChatResponse | null>, // ⭕️ 修正4: null 許容を追加
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getClassNames(classes: NurseryUserClassResponse[]): string {
      if (classes && classes.length > 0) {
        const names = classes.map((c) => c.className).filter(Boolean); // ⭕️ undefined除外
        return names.join(', ');
      } else {
        return '';
      }
    },
    getGroupNames(groups: NurseryGroupListResponse): string {
      if (groups && groups.length > 0) {
        const names = groups.map((g) => g.name).filter(Boolean); // ⭕️ undefined除外
        return names.join(', ');
      } else {
        return '';
      }
    },
    editMessage() {
      if (this.chat && this.isDraft) {
        chatEditModule.setTitle(this.chat.title || "");
        chatEditModule.setBody(this.chat.body || "");
        chatEditModule.setAttachmentUrls(this.chat.attachmentUrls?.length == 0 ? [] : this.chat.attachmentUrls);
        chatEditModule.setAttachmentDownloadUrls(this.chat.attachmentDownloadUrls?.length == 0 ? [] : this.chat.attachmentDownloadUrls);
        chatEditModule.setClassIds(this.chat.to.classes.map((c) => c.classId));
        this.$router.push({ path: '/mail/new', query: { id: String(this.chat.groupChatId) }});
      }
    },
  },
  computed: {
    sortedReadClassChildren(): any[] {
      if (!this.chat || !this.chat.readClassChildren) {
        return [];
      }

      const items = [...this.chat.readClassChildren];

      items.sort((a: any, b: any) => { 
        if (a.year !== b.year) {
          return a.year - b.year;
        }
        return a.childrenAge - b.childrenAge;
      });

      return items;
    },
  },
})
</script>